import styled from "styled-components";
import { Modal } from "antd";

const StyledModal = styled(Modal)`
  &.ant-modal {
    .ant-modal-header {
      margin-bottom: 32px;
    }

    .ant-modal-title {
      color: #1e1919;
      font-size: 18px;
      font-weight: 700;
    }

    .ant-modal-content {
      padding: 32px;
    }

    .ant-modal-footer {
      margin-top: 32px;

      .ant-btn {
        font-size: 14px;
        height: 40px;
      }
    }

    .container-template-options {
      background: #f7f4f4;
      border-radius: 12px;
      padding: 16px;

      .ant-form-item {
        margin-bottom: unset;
      }
    }
  }
`;

export default StyledModal;
